import { render, staticRenderFns } from "./baseSelectResearchCenter.vue?vue&type=template&id=5521e852&scoped=true&"
import script from "./baseSelectResearchCenter.vue?vue&type=script&lang=ts&"
export * from "./baseSelectResearchCenter.vue?vue&type=script&lang=ts&"
import style0 from "./baseSelectResearchCenter.vue?vue&type=style&index=0&id=5521e852&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5521e852",
  null
  
)

export default component.exports